import { render, staticRenderFns } from "./SwiperLatestNews.vue?vue&type=template&id=7827e984&"
import script from "./SwiperLatestNews.vue?vue&type=script&lang=js&"
export * from "./SwiperLatestNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports